<template>
  <div class="row">
    <div
      v-for="type in types"
      :key="type.id"
      class="col-xs-12 col-sm-4">
      <div class="box p-a">
        <transition
          name="fade"
          mode="out-in">
          <div
            key="content"
            class="content">
            <div class="pull-left m-r">
              <span :class="type.class">
                <i
                  class="material-icons"
                  v-html="type.icon"/>
              </span>
            </div>
            <div class="clear">
              <span>
                <h4 class="m-a-0 text-lg _300">
                  {{ Currency != null ? Currency : franchiseCurrency }}
                  <span v-if="!loading">{{ new Intl.NumberFormat('en', {minimumFractionDigits: 2}).format(type.total) }}</span>
                  <small
                    v-show="loading"
                    class="text-xs"><i class="fa fa-spinner fa-spin fa-2x"/></small>
                </h4>
              </span>
              <small class="text-muted">{{ type.name }}</small>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Laravel from '../../laroute';
import Currency from '@js/plugins/currency';
import Report from '@js/plugins/report';
import Auth from '@js/plugins/auth';
import Unleash from '@js/plugins/unleash';

export default {
    props: {
        Currency: {
            type: String,
            default: 'RM',
        },
    },

    data() {
        return {
            loading: true,
            types: [
                {
                    id: 0,
                    name: 'Cash',
                    total: null,
                    class: 'w-48 rounded accent',
                    icon: '&#xe227;',
                },
                {
                    id: 1,
                    name: this.trans('report.credit_transactions'),
                    total: null,
                    class: 'w-48 rounded primary',
                    icon: '&#xe8a1;',
                },
                {
                    id: this.trans('general.ewallet_type'),
                    name: `${this.trans('general.ewallet')}`,
                    total: null,
                    class: 'w-48 rounded info',
                    icon: '&#xe048;',
                },
                {
                    id: 3,
                    name: this.trans('report.voucher_transactions'),
                    total: null,
                    class: 'w-48 rounded success',
                    icon: '&#xe41d;',
                },
                {
                    id: 11,
                    name: 'Drive Off',
                    total: null,
                    class: 'w-48 rounded blue',
                    icon: '&#xe531;',
                },
            ],
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laravel.route(
                'franchise.report.transaction.getSumTransactionType',
                { id: this.outlet },
            );
        },

        outlet() {
            return this.$store.getters.activeOutlet;
        },

        franchiseCurrency() {
            return Currency.hasCurrency();
        },

        environment() {
            return Auth.metas().environment;
        },
    },

    watch: {
        outlet() {
            this.getSumTransaction();
        },

        dateFilter(a, b) {
            if (a == b) return;
            this.getSumTransaction();
        },

        filters: function(to, from) {
            if (to === from) return;
            this.getSumTransaction();
        },
    },

    mounted() {
        this.getSumTransaction();

        if (Report.pgsqlStrategy('transaction')) {
            // add support to display the local account & subsidy for both shell & bhp
            // add support to display by feature flag other clients
            if (
                this.environment === 'shell' ||
                this.environment === 'bhp' ||
                Unleash.hasFeature(
                    'transaction_dashboard_card_local_account_subsidy',
                )
            ) {
                this.types.push(
                    {
                        id: 4,
                        name: 'Local Account',
                        total: null,
                        class: 'w-48 rounded warning',
                        icon: '&#xe3f5;',
                    },
                    {
                        id: 12,
                        name: 'Subsidy',
                        total: null,
                        class: 'w-48 rounded blue',
                        icon: '&#xe8f6;',
                    },
                );
            }

            if (this.environment === 'shell') {
                this.types.push(
                    {
                        id: 'tng_rfid',
                        name: 'TNG RFID',
                        total: null,
                        class: 'w-48 rounded cyan',
                        icon: '&#xe3b0;',
                    },
                    {
                        id: 'ewallet_ghl',
                        name: 'Ewallet GHL',
                        total: null,
                        class: 'w-48 rounded primary',
                        icon: '&#xe30d;',
                    },
                    {
                        id: 'food_delivery',
                        name: 'Food Delivery',
                        total: null,
                        class: 'w-48 rounded success',
                        icon: '&#xe62c;',
                    },
                );
            }

            if (this.environment.includes('shell')) {
                this.types.push({
                    id: 'shell_app',
                    name: 'Shell App',
                    total: null,
                    class: 'w-48 rounded warn',
                    icon: '&#xe325;',
                });
            }

            // set the position of all transactions card to last
            this.types.push({
                id: -1,
                name: 'All Transactions',
                total: null,
                class: 'w-48 rounded warn',
                icon: '&#xe8de;',
            });
        }
    },

    methods: {
        getSumTransaction() {
            this.loading = true;

            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
                till_id: this.$store.getters.drawerSessionId,
                filters: this.filters,
            };

            this.$http.post(this.api, options).then(response => {
                var data = response.data;
                this.types = this.types.map(obj => {
                    obj.total = data[obj.id];
                    return obj;
                });

                this.loading = false;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/sumTransactionType.vue